module.exports = __webpack_public_path__ + "img/shanhu-tree3.e4bec7fb.png";